/*
 * json2csv.convert (Converts JSON to CSV)
 *
 * Available options:
 *  - separator: Character which acts as separator. For CSV use a comma (,).
 *               For TSV use a tab (\t).
 *  - flatten: Boolean indicating whether to flatten nested arrays or not.
 *             Optional. Default false.
 *  - output_csvjson_variant: Boolean indicating whether to output objects and
 *             arrays as is as per the CSVJSON format variant. Default is false.
 */
const errorMissingSeparator = 'Missing separator option.';
const errorNotAnArray = 'Your JSON must be an array or an object.';
const errorItemNotAnObject = 'Item in array is not an object: {0}';

export default {
    flattenArray(array, ancestors) {
        ancestors || (ancestors = []);

        function combineKeys(a, b) {
            var result = a.slice(0);
            if (!Array.isArray(b)) return result;
            for (var i = 0; i < b.length; i++)
                if (result.indexOf(b[i]) === -1) result.push(b[i]);
            return result;
        }

        function extend(target, source) {
            target = target || {};
            for (var prop in source) {
                if (typeof source[prop] === 'object') {
                    target[prop] = extend(target[prop], source[prop]);
                } else {
                    target[prop] = source[prop];
                }
            }
            return target;
        }

        var rows = [];
        for (var i = 0; i < array.length; i++) {
            var o = array[i], row = {}, orows = {}, count = 1;

            if (o !== undefined && o !== null && (!this.isObject(o) || Array.isArray(o)))
                throw errorItemNotAnObject.replace('{0}', JSON.stringify(o));

            var keys = this.getKeys(o);
            for (var k = 0; k < keys.length; k++) {
                var value = o[keys[k]];
                var keyChain = combineKeys(ancestors, [keys[k]]);
                var key = keyChain.join('.');
                if (Array.isArray(value)) {
                    orows[key] = this.flattenArray(value, keyChain);
                    count += orows[key].length;
                } else {
                    row[key] = value;
                }
            }

            if (count == 1) {
                rows.push(row);
            } else {
                keys = this.getKeys(orows);
                for (k = 0; k < keys.length; k++) {
                    var key2 = keys[k];
                    for (var r = 0; r < orows[key2].length; r++) {
                        rows.push(extend(extend({}, row), orows[key2][r]));
                    }
                }
            }
        }
        return rows;
    },

    isObject(o) {
        return o && typeof o == 'object';
    },

    getKeys(o) {
        if (!this.isObject(o)) return [];
        return Object.keys(o);
    },

    convert(data, options) {
        options || (options = {});

        if (!this.isObject(data)) throw errorNotAnArray;
        if (!Array.isArray(data)) data = [data];

        var separator = options.separator || ',';
        if (!separator) throw errorMissingSeparator;

        var flatten = options.flatten || false;
        if (flatten) data = this.flattenArray(data);

        var allKeys = [], allRows = [];
        for (var i = 0; i < data.length; i++) {
            var o = data[i], row = {};
            if (o !== undefined && o !== null && (!this.isObject(o) || Array.isArray(o)))
                throw errorItemNotAnObject.replace('{0}', JSON.stringify(o));
            var keys = this.getKeys(o);
            for (var k = 0; k < keys.length; k++) {
                var key = keys[k];
                if (allKeys.indexOf(key) === -1) allKeys.push(key);
                var value = o[key];
                if (value === undefined && value === null) continue;
                if (typeof value == 'string') {
                    row[key] = '"' + value.replace(/"/g, options.output_csvjson_variant ? '\\"' : '""') + '"';
                    if (options.output_csvjson_variant) row[key] = row[key].replace(/\n/g, '\\n');
                } else {
                    row[key] = JSON.stringify(value);
                    if (!options.output_csvjson_variant && (this.isObject(value) || Array.isArray(value)))
                        row[key] = '"' + row[key].replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"';
                }
            }
            allRows.push(row);
        }

        var keyValues = [];
        for (i = 0; i < allKeys.length; i++) {
        keyValues.push('"' + allKeys[i].replace(/"/g, options.output_csvjson_variant ? '\\"' : '""') + '"');
        }

        var csv = keyValues.join(separator)+'\n';
        for (var r = 0; r < allRows.length; r++) {
            row = allRows[r];
            var rowArray = [];
            for (k = 0; k < allKeys.length; k++) {
                key = allKeys[k];
                rowArray.push(row[key] || (options.output_csvjson_variant ? 'null' : ''));
            }
            csv += rowArray.join(separator) + (r < allRows.length-1 ? '\n' : '');
        }

        return csv;
    }
}